import Locomotive from '@/models/Locomotives/Locomotive'
import DieselLocomotive from '@/models/Locomotives/DieselLocomotive'
import DieselLocoSection from '@/models/Locomotives/DieselLocoSection'
import ElectricLocomotive from '@/models/Locomotives/ElectricLocomotive'
import ElectricLocoSection from '@/models/Locomotives/ElectricLocoSection'

export default class LocomotiveMapper {
    public map(data: any): Locomotive {
        if (data.locomotiveTypeCode === 'DI') {
            return this.mapDieselLocomotive(data)
        }
        if (data.locomotiveTypeCode === 'EL') {
            return this.mapElectricLocomotive(data)
        }
        throw Error('Not implemented')
    }

    private mapDieselLocomotive(data: any): DieselLocomotive {
        const locomotive = new DieselLocomotive()
        locomotive.type = data.locomotiveTypeCode
        locomotive.name = data.name
        locomotive.lastPosition = data.lastPosition
        locomotive.stationFrom = 'Test A'
        locomotive.stationTo = 'Test B'
        locomotive.controllerPosition = data.controllerPosition
        locomotive.mileage = data.mileage
        locomotive.trainNumber = data.train.number
        locomotive.trainWeight = '0'
        data.locoSections.forEach((ls: any) => {
            const dieselLocoSection = new DieselLocoSection()
            dieselLocoSection.code = ls.code
            dieselLocoSection.name = ls.name
            dieselLocoSection.index = ls.index
            dieselLocoSection.warningCount = ls.warningCount
            ls.parameters.forEach((p: any) => {
                (dieselLocoSection as any)[this.formatKey(p.key)] = p.value
            })

            locomotive.locoSections.push(dieselLocoSection)
        })
        return locomotive
    }

    private mapElectricLocomotive(data: any): ElectricLocomotive {
        const locomotive = new ElectricLocomotive()
        locomotive.type = data.locomotiveTypeCode
        locomotive.name = data.name
        locomotive.lastPosition = data.lastPosition
        locomotive.stationFrom = 'Test A'
        locomotive.stationTo = 'Test B'
        locomotive.controllerPosition = data.controllerPosition
        locomotive.mileage = data.mileage
        locomotive.trainNumber = data.train.number
        locomotive.trainWeight = '0'
        data.locoSections.forEach((ls: any) => {
            const electricLocoSection = new ElectricLocoSection()
            electricLocoSection.code = ls.code
            electricLocoSection.name = ls.name
            electricLocoSection.index = ls.index
            electricLocoSection.warningCount = ls.warningCount
            ls.parameters.forEach((p: any) => {
                (electricLocoSection as any)[this.formatKey(p.key)] = this.getValue(p.value, p.type)
            })

            locomotive.locoSections.push(electricLocoSection)
        })
        return locomotive
    }

    private mapLocoSection(data: any) {
        throw Error('Not implemented')
    }

    private formatKey(str: string): string {
        return str[0].toLowerCase() + str.slice(1);
    }

    private getValue(value: any, type: string): any {
        if (type === 'Decimal') {
            return Number(value)
        }

        if (type === 'Boolean') {
            return Boolean(value)
        }

        return value
    }
}